/**
 * Tealium audience integration
 * @module
 */

var Logger = require('core/utils/logger');
var WindowEnv = require('core/env/window');

/**
 * Local storage key for Tealium data.
 * @private
 */
var TEALIUM_KEY = 'tealium_va';
var VENDOR = 'tealium';

/**
 * Gets Tealium data from local storage.
 * @param {WindowEnv} window
 * @returns {string|undefined}
 * @private
 */
function getTealiumLocalStorageValue(window:any): string|undefined {
  try {
    return window.getGlobal('localStorage').getItem(TEALIUM_KEY);
  } catch(e) {
    Logger.warn('Error reading from local storage for ' + VENDOR, ':', e);
  }
}

var VENDOR = 'tealium';
var _ = require('optimizely-client-fn');
var JSONEnv = require('core/lib/json');

let pluginAudienceTealium: AudiencePluginConfig = {
  provider: {
    getter: [
      function() {
        var data = {audiences: [], badges: []};
        var localData = getTealiumLocalStorageValue(WindowEnv);
        if (localData) {
          try {
            var visData = JSONEnv.parse(localData);
            if (visData.audiences) {
              data.audiences = _.keys(visData.audiences);
            }
            if (visData.badges) {
              data.badges = _.keys(visData.badges);
            }
            return data;
          } catch (e) {
            Logger.warn('Error parsing local storage data for ' + VENDOR, ':', e);
          }
        }
      },
    ]
  },
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceTealium);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceTealium;
}
